export { OurCommitmentFeature } from "./lib/our-commitment";
export { getStaticProps } from "./lib/get-static-props";
